import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import Business from "@material-ui/icons/Business";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";
import Timeline from "@material-ui/icons/Timeline";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import InfoArea from "../../../components/InfoArea/InfoArea.jsx";

import servicesStyle from "../../../assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
    const { classes } = props;
    return (
        <div className={classes.services}>
            <GridContainer>
                <GridItem md={4} sm={4}>
                    <InfoArea
                        title="La Empresa"
                        description={
                            <span>
                                <p>
                                Vivamos el Campo SAS (NIT No 901128377-0 y RNT 135625) es un Operador de Plataformas
                                Electrónicas o Digitales de Servicios Turísticos (Ley 2068 de 2020) dedicada al Turismo Rural,
                                siendo pionera en promover y ofrecer servicios de este tipo en Colombia. Nos especializamos en
                                la intermediación y operación entre dos sectores de usuarios: Los propietarios de alojamientos
                                rurales y Prestadores de Servicios Turísticos (PST) con RNT, conectándolos con turistas
                                nacionales y extranjeros. Nuestro objetivo es brindar una experiencia única y auténtica,
                                conectando a los viajeros con la belleza natural y cultural de las zonas rurales de Colombia.{" "}
                                </p>
                            </span>
                        }
                        icon={Business}
                        iconColor="success"
                    />
                </GridItem>
                {/**
                 TODO: Mejorar la redaccion de mision y vision
                 */}
                <GridItem md={4} sm={4}>
                    <InfoArea
                        title="Misión"
                        description={
                            <span>
                                <p>
                                    Realizar una conexión comercial online entre los propietarios de Alojamientos
                                    Rurales que cuenten con Registro Nacional de Turismo (RNT), los artesanos,
                                    servicios conexos, y también con los Turistas Nacionales y Extranjeros,
                                    de tal forma que podamos fomentar el Turismo Rural respetando el valor cultural
                                    y ambiental de cada uno de los alojamientos y destinos turísticos, haciéndolos
                                    sostenibles y colaborando en el desarrollo social del sector en el cual se
                                    desarrolla el Turismo Rural.
                                </p>
                            </span>
                        }
                        icon={AssignmentTurnedIn}
                        iconColor="success"
                    />
                </GridItem>
                <GridItem md={4} sm={4}>
                    <InfoArea
                        title="Visión"
                        description={
                            <span>
                                <p>
                                    Expandirnos con el fin de llegar a todos los lugares en los cuales se presten
                                    servicios de Turismo Rural, buscando ser líderes en la promoción de Alojamientos
                                    y Servicios Turísticos Rurales en el territorio Colombiano, y por que no,
                                    en el extranjero. Vivamos el Campo espera ser un aliado de las instituciones que
                                    impulsen y generen conocimiento relacionado con buenas prácticas a la hora
                                    de prestar actividades turísticas y de hospedaje, buscando ser un promotor de
                                    los procesos de legalización de los Prestadores de Servicios Turísticos, esperando
                                    convirtirse así en un ente capacitador para los Propietarios de
                                    Alojamientos Rurales.
                                </p>
                            </span>
                        }
                        icon={Timeline}
                        iconColor="success"
                    />
                </GridItem>
            </GridContainer>
        </div>
    );
}

export default withStyles(servicesStyle)(SectionServices);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/SectionServices.jsx